export default "__VITE_ASSET__CGlGatUu__"